export enum StudentTypeEnum {
  SCHOOL = 'SCHOOL',
  REGULAR = 'REGULAR',
  CONECTA_INTERNAL = 'CONECTA_INTERNAL',
  CONECTA_EXTERNAL = 'CONECTA_EXTERNAL',
}
